import '../css/app.css';
import '../css/styles.scss';
import './bootstrap';

import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createApp, h } from 'vue';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';
import { createPinia } from 'pinia';
import Aura from '@primevue/themes/aura';
import { definePreset } from '@primevue/themes';
import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';
import Toast from 'primevue/toast';
import { VueRecaptcha } from 'vue-recaptcha';
import { appName } from '@/config/app';
import AppRoute from '@/router';
import 'primeicons/primeicons.css';
import '@material-symbols/font-300';

const customPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{amber.50}',
      100: '{amber.100}',
      200: '{amber.200}',
      300: '{amber.300}',
      400: '{amber.400}',
      500: '{amber.500}',
      600: '{amber.600}',
      700: '{amber.700}',
      800: '{amber.800}',
      900: '{amber.900}',
      950: '{amber.950}',
    },
    colorScheme: {
      light: {
        primary: {
          color: '{amber.600}',
          inverseColor: '#ffffff',
          hoverColor: '{amber.700}',
          activeColor: '{amber.800}',
        },
      },
    },
  },
});

createInertiaApp({
  title: (title) => `${title} - ${appName}`,
  resolve: () =>
    resolvePageComponent(`./App.vue`, import.meta.glob('./**/*.vue')),
  setup({ el, App, props, plugin }) {
    return createApp({
      render: () => h(App, props),
    })
      .use(plugin)
      .use(AppRoute)
      .use(createPinia())
      .use(PrimeVue, {
        ripple: true,
        locale: {
          firstDayOfWeek: 0,
        },
        theme: {
          preset: customPreset,
          ripple: true,
          options: {
            darkModeSelector: '.mz-dark',
            cssLayer: {
              name: 'primevue',
              order: 'tailwind-base, primevue, tailwind-utilities',
            },
          },
        },
      })
      .use(ToastService)
      .use(ConfirmationService)
      .use(ZiggyVue)
      .component('Toast', Toast)
      .component('vue-recaptcha', VueRecaptcha)
      .mount(el);
  },
  progress: {
    color: '#4B5563',
  },
});
